.fg49l20 {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  background-color: var(--_1qu8za2g);
  padding: 24px;
  padding-bottom: 0;
  overflow: hidden;
  padding-right: 0;
  border-radius: 12px;
  border: 1px solid var(--_1baaexs5);
  margin-bottom: 16px;
}
.fg49l21 {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 24px;
}
.fg49l22 {
  font-weight: 700;
  font-size: 16px;
  line-height: 1.3;
  letter-spacing: -0.02em;
  margin-bottom: 8px;
}
.fg49l23 {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.3;
  letter-spacing: -0.01em;
}
.fg49l24 {
  width: fit-content;
  min-width: 150px;
}
.fg49l25 {
  position: relative;
  height: fit-content;
  align-self: flex-start;
  width: 450px;
  max-width: 110px;
}
.fg49l26 {
  position: absolute;
  border-top-left-radius: 12px;
  right: 0;
  top: 0;
  left: 0;
  width: 450px;
}
@media screen and (min-width: 768px) {
  .fg49l25 {
    max-width: 350px;
  }
}
@media screen and (min-width: 1024px) {
  .fg49l25 {
    max-width: 400px;
  }
}
@media screen and (min-width: 1280px) {
  .fg49l25 {
    max-width: 450px;
  }
}